import { cn } from '@/lib/shadcn/utils';
import { Heading } from '@/modules/ui/components/heading/Heading';
import { Subheading } from '@/modules/ui/components/subheading/Subheading';

interface SignupFlowHeaderProps {
  title: string;
  subtitle: React.ReactNode;
  className?: string;
}

export const SignupFlowHeader = ({
  title,
  subtitle,
  className,
}: SignupFlowHeaderProps) => {
  return (
    <div className={cn('flex flex-col gap-2 text-center', className)}>
      <Heading variant="h2" className="text-foreground">
        {title}
      </Heading>
      <Subheading variant="h5" className="font-normal text-neutral-600">
        {subtitle}
      </Subheading>
    </div>
  );
};
